// VARIANCE_TABLE — analyst internal model vs InSync consensus (Numbers step).
// (re-saved to re-trigger the CRA module resolver after git restore)
import React from 'react';
import VarianceTableWidgetBuilder from './VarianceTableWidgetBuilder';
import VarianceTableWidgetRenderer from './VarianceTableWidgetRenderer';
import type { WidgetDefinition } from '../../../registry';
import type { VarianceTableWidgetConfig } from './types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faScaleBalanced } from '@fortawesome/free-solid-svg-icons';

export { default as VarianceTableWidgetBuilder } from './VarianceTableWidgetBuilder';
export { default as VarianceTableWidgetRenderer } from './VarianceTableWidgetRenderer';
export * from './types';

export const definition: WidgetDefinition = {
  type: 'variance_table',
  meta: {
    label: 'Variance Table',
    icon: React.createElement(FontAwesomeIcon, { icon: faScaleBalanced }),
    description: 'Analyst internal model vs InSync consensus variance grid (KPI x period)',
    isSystem: true,
    isCreatable: true,
    requiresAsset: true,
    dataFlow: 'display',
  },
  dataProvider: {
    widget: 'VARIANCE_TABLE',
    params: [],
  },
  defaultSize: { w: 24, h: 8, minW: 8, minH: 5 },
  defaultConfig: () => ({} as VarianceTableWidgetConfig),
  Builder: VarianceTableWidgetBuilder,
  Renderer: VarianceTableWidgetRenderer,
  // Inline preview (renders the asset-less Renderer) — avoids a separate
  // Preview.tsx the CRA dev-server watcher fails to pick up on WSL2.
  Preview: () => React.createElement(VarianceTableWidgetRenderer, { config: {} }),
};
